import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import { selectManageTemplateFilterShowIncludedTemplateValue } from '../../store/useManageTemplateFilterStore';
import style from './style.module.scss';

const TableEquipmentsSkeleton = () => {
  const showIncludedTemplateValue = selectManageTemplateFilterShowIncludedTemplateValue();

  const columnsCount = showIncludedTemplateValue ? 6 : 5;

  return [...Array(10)].map(() => (
    <tr key={uuidv4()} className={style.skeletonRow}>
      {[...Array(columnsCount)].map(() => (
        <td key={uuidv4()}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
      ))}
    </tr>
  ));
};

export default TableEquipmentsSkeleton;
